import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9058 9C20.2878 9 20.6548 9.057 20.9998 9.162V9C20.9998 8.20435 20.6838 7.44129 20.1211 6.87868C19.5585 6.31607 18.7955 6 17.9998 6H14.1208C13.922 5.99982 13.7313 5.92069 13.5908 5.78L11.4698 3.66C11.261 3.45089 11.013 3.28497 10.74 3.17173C10.467 3.05848 10.1744 3.00013 9.87882 3H5.99982C5.20417 3 4.44111 3.31607 3.8785 3.87868C3.31589 4.44129 2.99982 5.20435 2.99982 6V9.162C3.3545 9.05431 3.72316 8.99972 4.09382 9H19.9058ZM4.09382 10.5C3.77151 10.5001 3.45298 10.5694 3.15978 10.7032C2.86658 10.8371 2.60556 11.0324 2.3944 11.2759C2.18323 11.5194 2.02684 11.8054 1.93582 12.1146C1.8448 12.4238 1.82127 12.7489 1.86682 13.068L2.72382 19.068C2.80037 19.6041 3.06772 20.0947 3.4768 20.4496C3.88589 20.8045 4.40925 20.9999 4.95082 21H19.0498C19.5914 20.9999 20.1148 20.8045 20.5238 20.4496C20.9329 20.0947 21.2003 19.6041 21.2768 19.068L22.1338 13.068C22.1794 12.7489 22.1558 12.4238 22.0648 12.1146C21.9738 11.8054 21.8174 11.5194 21.6063 11.2759C21.3951 11.0324 21.1341 10.8371 20.8409 10.7032C20.5477 10.5694 20.2291 10.5001 19.9068 10.5H4.09382Z"
        fill={colorValue}
      />
    </svg>
  );
};
